import {createStore} from 'vuex'

export default createStore(
    {
        state: {
            username: null,
            role: null,
            id: null
        },
        mutations: {
            login: (state, response) => {
                if (response) {
                    state.username = response.data.username
                    state.role = response.data.role
                    state.id = response.data.id
                }
            },
            logout: (state) => {
                state.username = null
                state.role = null
                state.id = null
            }
        },
        getters: {
            getUsername: (state) => {
                return state.username
            },
            getRole: (state) => {
                return state.role
            },
            asJson: (state) => {
                return JSON.stringify(
                    {
                        username: state.username,
                        role: state.role,
                        id: state.id
                    }
                )
            }
        }
    }
)
